import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="bg-blue-600 text-white px-6 py-4 mb-4">
      <Link to="/" className="text-2xl font-semibold">ReactDocs Blog</Link>
    </nav>
  );
}
